export default {
    // title: "Meter Data Management System",
    currency: {
        no: "No.",
        search: 'Search',
        submitText: "submit",
        clearText: "Clear",
        refresh: 'Refresh',
        cancelText: 'Cancel',
        success: "Operate success!",
        confirmDelete: "This operation will delete data permanently. Do you want to continue?",
        tip: "Tip",
        warning: "Warning",
        confirm: "Confirm",
        cancel: "Cancel",
        addSuccess: "Added successfully!",
        editSuccess: "Successfully modified!",
        deleteSuccess: "Successful deletion!",
        confirmDeletion: "This menu has been associated with other roles. Are you sure you want to delete it?",
    },
    estimateRuleMgt: { sheetName: "Estimated rule management" },
    logout: {
        logout: "Are you sure to log out and exit the system?",
        confirm: "Confirm",
        successTologOut: "The password is changed successfully, please log in again!"
    },
    login: {
        login: "Login",
        password2: "Please enter password",
        accountLength: "Account length should not exceed 20 characters",
        passformat: "Password length is between ",
        passformatT: "digits and contain symbols, numbers and letters",
        enterUsername: "Please enter username",
        enterPassword: "Please enter password",
        enterLength: "Password length must not be less than 6 characters",
        enterCaptcha: "Please enter verification code",
        captchaError: "Wrong Format",
        userontexist: "User does not exist",
        vercode: "Verification code expired or wrong",
        userwrong: "User password is wrong",
        passtime: "Too many password errors, please try in 10 minutes",
        acclock: "Account is locked, please contact the administrator",
        accstop: "Account has been disabled, please contact the administrator",
        accabnomal: "Account abnormal, please contact the administrator",
        noper: "Account has been deleted, please contact the administrator",
        frozen: "Account has been frozen, please contact the administrator",
        hint: "System prompt",
        register: "Re-register",
        missing: "The login status has expired, please log in again!",
        expired: "This account has been logged in on other platforms, please log in again!",
        logging: "Logging in, please wait. . .",
        refersh: "Click refresh",
        logged: "The account has been logged in,do you want to continue?"
    },
    route: {
        main: "Main Categories",
        dashboard: "Dashboard",
        AssetManagement: "Asset MGT",
        MeterArchivesManagement: "Meter Archives MGT",
        MeterReplaceManagement: "Meter Replace MGT",
        DCUArchivesManagement: "DCU Archives MGT",
        DCUReplaceManagement: "DCU Replace MGT",
        OrganizationManagement: "Organization MGT",
        CustomerManagement: "Customer MGT",
        SAPManagement: "SAP MGT",
        WFMSManagement: "WFMS MGT",
        MeterReadingManagement: "Meter Reading MGT",
        MeterReadingTemplateSettings: "Meter Reading Template Settings",
        MeterReadingTaskRelease: "Meter Reading Task Release",
        MonthlySettlementManagement: "Monthly Settlement MGT",
        VEEManagement: "VEE MGT",
        VerificationRuleManagement: "Verification Rule MGT",
        EstimateRuleManagement: "Estimate Rule MGT",
        MeterDataExceptionMGT: "Meter Data Exception MGT",
        MeterViewDataExceptionManagement: "Meter View Data Exception MGT",
        MeterProfileDataExceptionManagement: "Meter Profile Data Exception MGT",
        DataQuery: "Data Query",
        LoadViewQuery: "Load View Query",
        LoadProfileQuery: "Load Profile Query",
        TOUViewQuery: "TOU View Query",
        TOUProfileQuery: "TOU Profile Query",
        EOBViewQuery: "EOB View Query",
        EOBProfileQuery: "EOB Profile Query",
        LossManagement: "Loss MGT",
        LossSummary: "Loss Summary",
        LossTemplateManangement: "Loss Template MGT",
        reportquery: "Report Query",
        LossQuery: "Loss Query",
        CommandManagement: "Command MGT",
        ConnectAndDiconnect: "Connect And Diconnect",
        RemoteUpgrade: "Remote Upgrade",
        system: "System MGT",
        UserManangement: "User MGT",
        userGroup: "User Group MGT",
        DeviceGroupManagement: "Device Group MGT",
        OrganizationModel: "Dept MGT",
        MenuManagement: "Menu MGT",
        RoleManagement: "Role MGT",
        profile: 'Profile',
    },
    navbar: {
        home: 'Home',
        product: 'Product',
        solution: 'Solution',
        shop: 'Shop',
        customization: 'Customization',
        community: 'Community',
        aboutUs: 'About Us',
        contact: 'Contact',
        lang:'中文',
        // community: 'Community'
        ioTHardware:'IoT Hardware',
        electricEquipment:'Electric Equipment',
        softwarePlatform:'Software & Platform',
        discord:'Discord',
        twitter:'Twitter'
    },
    //轮播
    rotation:{
        
    },
    home:{
        title:"Professional provider of electrical",
        weprovideq:"Overall solutions for 5G wireless",
        weprovideTow:"private networks in various industries",
        titleTow:"and IoT Solution",
        // viewSolutions:"View Solutions",
        viewSolutions:"View Solutions",
        whatcan:"What can we do",
        ourService:"Our Service",
        ioTHardware:"IoT Hardware",
        softwarePlatform:"Software & Platform",
        solution:"Solution",
        focuson:"Focus on IoT hardware R&D, serving power, meteorology and other fields",
        webbased:"Web-based equipment manage- ment and data display platform",
        solution:"Solution",
        providesolutions:"Provide solutions for electricity, meteorology, and other industries",
        ourAdvantages:"Our Advantages",
        whychoose:"Why choose us",
        yearof:"Year of  R&D",
        servingcountries:"Serving countries",
        globalusers:"Global users",
        servingFortune:"Serving Fortune Global 500",
        patents:"Patents",
        globalPartners:"Global partners",
        ourProducts:"Our Products",
        werecommend:"We recommend these for you",
        gateway:"Pisces P100 LoRa Outdoor Gateway EU868/US915",
        module:"GPMLx9332-PX V3, LoRa Module, EU868/US915",
        electricMeter:"LoRa FRP Antenna, 4dBi, EU868/US915",
        electricMeters:"LoraWAN Rail-Type Smart Energy Meter",

        abrief:"A high-performance LoRaWAN product that supports Longfi technology, it can process a large amount of data on the helium network.",
        abriefTow:"It was developed based on digital baseband chip sx1302, adopt the mechanical definition of mini PCIe interface and provide SPI interface.",
        abriefThree:"A high-precision, high-gain antenna that is easy to install and suitable for various complex environments.",
        abriefFour:"A smart electricity meter that complies with LoRaWAN protocol，and it can connect to the helium network.",
        
        details:"Details",
        more:"More",
        ourSolutions:"Our Solutions",
        weprovide:"We provide overall industry solutions",
        viewallSolution:"View all Solution",
        smartCampus:"Smart Campus",
        basedon:"Based on the Internet of Things, the entire park is highly informatized.",
        smartStreetLight:"Smart Street Light",
        effectivelycontrol:"Effectively control energy consumption and greatly save power resources.",
        ami:"AMI",
        anautomatic:"AMI is an overall architecture that integrates existing and new power technologies, including smart metering, data collection terminals, special transformer negative control terminals, interactive terminals, electricity sales terminals, communication networks with data centers, and data collection management and data application platforms. .",
        ourPartners:"Our Partners",
        clickon:"Click on the image to get direct to the website",
    },
    solution:{
        title:"Solution",
        all:"All",
        energy:"Energy",
        agricultural:"Agricultural",
        smartCity:"Smart City",
        
        ami:"AMI",
        smartStreetLight:"Smart Street Light",
        smartCampus:"Smart Campus",
        smartAgricultural:"Smart Agricultural",
        aPPbasedPrepaid:"APP-based Prepaid",
        basestationEnergySaving:"5G base station Energy Saving",
        substationNR:"Substation NR Private Network",
        wirelessSecurity:"Wireless Security Monitoring",
        wirelessMetering:"Wireless Metering",
          
        anautomatic:"AMI is an overall architecture that integrates existing and new power technologies, including smart metering, data collection terminals, special transformer negative control terminals, interactive terminals, electricity sales terminals, communication networks with data centers, and data collection management and data application platforms. .",
        animportant:"An important part of smart cities, connecting street lights in cities to form the IoT",
        theentire:"The entire campus is highly informatized in terms of energy, environment and safety",
        basedon:"Based on the IoT, realize unmanned, automated and intelligent management.",
        userscan:"Users can use the APP to prepay electricity, water, rent, etc.",
        significantly:"Significantly reduces power consumption and manual operations in base station.",
        reliableandseamless:"Safe, reliable and seamless communication coverage of the intranet in the substation.",
        throughwireless:"Through wireless transmission, 24-hour real-time monitoring of important locations.",
        flexiblesystem:"Flexible system networking and single-point independent networking, etc."
    },
    customization:{
        title:"Customization",
        greenPalm:"GreenPalm",
        cutomi:"Cutomization",   
        zationService:"Service",
        sometimesthe:"Sometimes the perfect solution doesn't exist, and when existing solutions don't meet your needs, we can provide customization services to create hardware and software for you.",
        wehavemany:"We have many years of development experience and a number of successful cases in the following fields:",
        ami:"AMI",
        smartAgricultural:"Smart Agricultural",
        smartStreetLight:"Smart Street Light",
        aPPbased:"APP-based Prepaid",
        smartCampus:"Smart Campus",
        basestation:"5G base station Energy Saving",
        hardware:"Hardware Cutomization",
        withouradvanced:"With our advanced production lines and extensive hardware R&D experience, we can provide unparalleled hardware customization. Customized content:",
        boardfunctionality:"Board functionality",
        memoryUnit:"Memory Unit",
        sensorActuator:"Sensor, Actuator, and Connector Integration",
        schematicDesign:"Schematic Design",
        pcbLayout:"PCB Layout",
        creatingBOMssourcing:"Creating BOMs & sourcing",
        expansions:"Expansions: Cape, Shield, Hats",
        
        softwareCutomization:"Software Cutomization",
        ourdevelopers:"Our developers are familiar with most operating systems and programming languages, no matter what your requirements are, we can customize the software and platforms you need. Customized content:",
        industryType:"Industry Type",
        applicationScenarios:"Application Scenarios",
        businessNeeds:"Business Needs",
        operatingPlatform:"Operating Platform",
        userInterface:"User Interface",
        customizationProcess:"Customization Process",

        discussion:"Discussion",
        solutionProposal:"Solution Proposal",
        development:"Development",
        handOver:"Hand Over",
        afterService:"After Service",
        toknow:"To know what exactly the client´s problem is and how we can help.",
        createdconcrete:"Created concrete solution proposal based on the disscussion with client.",
        theactual:"The actual work on the project lasts for a particular time.",
        afterthe:"After the product has been finished, it is handed over to the client. ",
        afterhand:"After hand over, we will provide necessary services for free or for a fee",
        letUsBuild:"Let Us Build You Customization",
        writeamessage:"Write a message",
        yourName:"Your Name",
        yourEmail:"Your Email",
        yourPhone:"Your Phone",
        message:"Message",
        submit:"Submit",
        contactinformation:"Contact information",
        ourEmail:"Our Email",
        trade:"trade01@greenpalm.cn",
        ourAddress:"Our Address",
        // room:"Room 412, Building C, Hangzhouwan Information Harbor, No.198 Qidi Road, Beigan Street, Xiaoshan District, Hangzhou,Zhejiang Province,China", 
        room:"No. 2 Floor, Building 1, 4368 Jianshe Fourth Road, Xinjie Street, Xiaoshan District, Hangzhou City,Zhejiang Province", 
    },
    about:{
        title:"About Us",
        aboutUs:"About Us",
        pofessionalprovider:"Pofessional provider of electrical and IoT Solution",
        hangzhouGreenPalmo:"Hangzhou GreenPalm Technology Co. Ltd. was established in 2012, specializing in the  research, development and production of electricity information collection platform, hardware, IOT solutions and equipment.", 
        wehavemore:"We have more than 40 R&D and technical engineers, and have set up several R&D teams with product series as the main line, with smart grid industry experts who have been engaged in R&D for many years as project team leaders, with clear division of labor and responsibilities. ",
        greenPalmis:"GreenPalm is committed to the disruptive innovation of green energy based on IOT & Internet technology, green energy saving innovation and integrated energy station construction. Our products spreading to more than 40 countries in five continents.",
        ioTHardware:"IoT Hardware",
        softwarePlatform:"Software&Platform",
        solution:"Solution",

        globalLayout:"Global Layout",
        servingcountries:"Serving countries",
        globalusers :"Global users",
        servingFortune:"Serving Fortune Global 500",
        globalbranch:"Global branch",
        globalpartners :"Global partners",

        branchs:"Branchs",
        hangzhouGreenPalm:"Hangzhou GreenPalm",
        jiangsuGreenPalm :"Jiangsu GreenPalm",
        middleeast:"Middle East R&D Center",
        southAmericanR:"South American R&D Center",
        singaporeGreenPalm:"Singapore GreenPalm",
        northAmerican:"North American Service Center",

      


        productionEnvironment:"Production Environment",
        ourMajor:"Our Major Clients and Partners",
        certification:"Certification",

    },
    contact:{
        title:"Contact",
        writeamessage:"Write a message",
        yourName:"Your Name",
        yourEmail:"Your Email",
        yourPhone:"Your Phone",
        message:"Message",
        submit:"Submit",
        contactinformation:"Contact information",
        ourEmail:"Our Email",
        trade:"trade01@greenpalm.cn",
        ourAddress:"Our Address",
        // room:"Room 412, Building C, Hangzhouwan Information Harbor, No.198 Qidi Road, Beigan Street, Xiaoshan District, Hangzhou,Zhejiang Province,China",
        room:"No. 2 Floor, Building 1, 4368 Jianshe Fourth Road, Xinjie Street, Xiaoshan District, Hangzhou City,Zhejiang Province", 

    },
    bottom:{
        hangzhouGreenPalm:"Hangzhou GreenPalm Technology Co., Ltd.",
        community:"Community:",
        navigation:"Navigation",
        home:"Home",
        solution:"Solution",
        shop:"Shop",
        customization:"Customization",
        aboutUs:"About Us",
        contactUs:"Contact Us",
        // room:"Room 412, Building C, Hangzhouwan Information Harbor, No.198 Qidi Road, Beigan Street, Xiaoshan District, Hangzhou, Zhejiang Province, China",
        room:"No. 2 Floor, Building 1, 4368 Jianshe Fourth Road, Xinjie Street, Xiaoshan District, Hangzhou City,Zhejiang Province", 
        trade:"trade01@greenpalm.cn",
        copyright:"Copyright © 2021 Hangzhou GreenPalm Technology Co., Ltd. | 浙ICP备18035527号-2",
    },
    message:{
        userName:"Please enter your name",
        userEmail:"Please enter your email address",
        correctUserEmail:"Please enter the correct email address",
        userPhone:"Please enter your mobile phone number (including area code)",
        userMessage:"Please enter your message",
        successfully:"Sent successfully"
    }
}


// WEBPACK FOOTER //
// ./src/lang/en/base.js